import Swiper, { Navigation } from 'swiper';
import 'swiper/swiper-bundle.css';
Swiper.use([Navigation]);
const swiperLazyLoad = (el) => {
    const lazy = el.querySelector('[data-background-image]');
    if (lazy) {
        const bg = lazy.dataset.backgroundImage;
        lazy.style.backgroundImage = `url(${bg})`;
    }
};
const getTestimonialsConfig = () => {
    return {
        direction: 'horizontal',
        threshold: 10,
        loop: true,
        spaceBetween: 24,
        // Navigation arrows
        navigation: {
            nextEl: '.swiper-button-next',
            prevEl: '.swiper-button-prev',
        },
        on: {
            slideChange: (swiper) => {
                // BG for first one is loaded by lozad when testimonials section appears on screen
                // The rest one is loaded by swiper on slide change event, because lozad is buggy in some cases
                if (swiper.activeIndex !== 1) {
                    swiperLazyLoad(swiper.slides[swiper.activeIndex]);
                }
            },
        },
    };
};
const getStoriesConfig = () => {
    return {
        direction: 'horizontal',
        threshold: 10,
        loop: false,
        slidesPerView: 'auto',
        centeredSlides: true,
        // Navigation arrows
        navigation: {
            nextEl: '.swiper-button-next',
            prevEl: '.swiper-button-prev',
        },
    };
};
const getConfig = (el) => {
    if (el.dataset.swiperTestimonialConfig) {
        return getTestimonialsConfig();
    }
    if (el.dataset.swiperStoriesConfig) {
        return getStoriesConfig();
    }
    return {};
};
export function swiperWrapper(el) {
    return new Swiper(el, getConfig(el));
}
